import { API_ROUTES } from "../constants/routes";
import axios from "axios";

export default class REQUEST_SERVICE {

  static all = async () => {
    try {
      const res = await axios.get(API_ROUTES.REQUEST.ALL);
      return res?.data;
    } catch (error) {
      return error.response.data;
    }
  };

  static create = async (data) => {
    try {
      const res = await axios.post(API_ROUTES.REQUEST.CREATE, data);
      return res?.data;
    } catch (error) {
      return error.response.data;
    }
  };

  static destroy = async (id) => {
    try {
      const res = await axios.delete(API_ROUTES.REQUEST.DELETE+id);
      return res?.data;
    } catch (error) {
      return error.response.data;
    }
  };

  static update = async (id, data) => {
    try {
      const res = await axios.put(API_ROUTES.REQUEST.UPDATE+id, data);
      return res?.data;
    } catch (error) {
      return error.response.data;
    }
  };

}